$component-class: 'me-section';

.#{$component-class} {
  width: 100%;
}
